import { GetStatesDocument } from '@/api/queries';
import SelectFromQuery from '../SelectFromQuery';

const SelectState = (props) => (
  <SelectFromQuery
    cache="State"
    placeholder="All States"
    query={GetStatesDocument}
    selector={(data) =>
      (data?.getFilters?.filters?.states || []).map((opt) => ({
        label: opt.displayName,
        value: opt.id,
        values: opt.values,
      }))
    }
    {...props}
  />
);

export default SelectState;
